import { useCreateLicenseMutation } from '../../api/api-hooks';
import { SoftwareSoldItemForm } from './softwareSoldTypes';

const useLicenseItemCreator = () => {
  const [createLicense] = useCreateLicenseMutation();
  return async (item: SoftwareSoldItemForm) => {
    if (
      item.hardware === null ||
      item.hardware === undefined ||
      item.company === null ||
      item.company === undefined ||
      item.software === null ||
      item.software === undefined ||
      item.license === '' ||
      item.license === undefined
    )
      return { error: { data: { message: 'Missing required fields' } } };
    // Process any modules, removing duplicates
    const modulesAddedById: number[] = [];
    for await (const module of item.modulesToAdd) {
      if (
        module.license === undefined ||
        module.license === '' ||
        !module.module ||
        modulesAddedById.includes(module.module.id)
      )
        continue;
      await createLicense({
        createLicenseDto: {
          license: module.license,
          hardwareId: Number(item.hardware.id),
          companyId: Number(item.company.id),
          softwareId: Number(item.software.id),
          orderId: item.order ? item.order.id : null,
          moduleId: module.module.id,
        },
      });
      modulesAddedById.push(module.module.id);
    }
    // Process main license
    return createLicense({
      createLicenseDto: {
        license: item.license,
        hardwareId: Number(item.hardware.id),
        companyId: Number(item.company.id),
        softwareId: Number(item.software.id),
        orderId: item.order ? item.order.id : null,
        moduleId: item.module ? item.module.id : null,
        notes: item.notes,
      },
    });
  };
};

export default useLicenseItemCreator;
